<div *ngIf="loadingStatus" class="loading" [ngClass]="{'loading--no-bg': noBg}">
  <ion-spinner
    name="circular"
    class="loading-spinner"
    color="primary"
  ></ion-spinner>

  <!-- <i class="fa-regular fa-spinner-third fa-spin fa-2xl"></i> -->
</div>
